var $25bedea7b332a070$exports = {};
$25bedea7b332a070$exports = {
    "collectionLabel": `Sugestie`
};


export {$25bedea7b332a070$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
